import React from "react";

import Heading from "@common/components/Heading/Heading";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";

interface CrashFreeSessionsCardProps extends ReleaseMetricCardBaseProps {
  rate: number;
}

const CrashFreeSessionsCard = ({ style, rate, score, highlight, error, onMoreClick }: CrashFreeSessionsCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"Crash-free sessions"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex $column>
        <Flex style={{ alignItems: "center" }}>
          <Heading
            heading2
            style={{ marginRight: "1.8rem" }}
            marginBottom={0}
          >{`${rate.toString()}%`}</Heading>
        </Flex>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { CrashFreeSessionsCard };
